import { useState } from 'react';
import { useSelector } from 'react-redux';
import { deleteMenuItem } from '../../helpers/api_helper';

const useDeleteMenuItem = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const tenantId = useSelector((state) => state.Context.tenantId);

    const deleteMenuItemHook = async (id) => {
        setLoading(true);
        setError(null);
        try {
            const response = await deleteMenuItem(tenantId, id);
            return response;
        } catch (err) {
            const errorMessage = `Failed to delete menu item: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { deleteMenuItem: deleteMenuItemHook, loading, error };
};

export default useDeleteMenuItem;